"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WHCM_SELECTED_ITEM_OUTLINE_WIDTH = exports.WHCM_SELECTED_ITEM_OUTLINE_OFFSET = exports.WHCM_ITEM_COLOR = exports.WHCM_HIGHLIGHT_COLOR = exports.WHCM_FOCUSED_ITEM_BORDER_WIDTH = exports.OUTLINE_WIDTH = exports.OUTLINE_OFFSET = exports.NOT_SELECTED_OUTLINE_OFFSET = exports.BORDER_WIDTH = void 0;
var WHCM_SELECTED_ITEM_OUTLINE_WIDTH = 4;
exports.WHCM_SELECTED_ITEM_OUTLINE_WIDTH = WHCM_SELECTED_ITEM_OUTLINE_WIDTH;
var WHCM_SELECTED_ITEM_OUTLINE_OFFSET = -2;
exports.WHCM_SELECTED_ITEM_OUTLINE_OFFSET = WHCM_SELECTED_ITEM_OUTLINE_OFFSET;
var WHCM_FOCUSED_ITEM_BORDER_WIDTH = 2; //Windows system color for highlighted items in WHCM

exports.WHCM_FOCUSED_ITEM_BORDER_WIDTH = WHCM_FOCUSED_ITEM_BORDER_WIDTH;
var WHCM_HIGHLIGHT_COLOR = 'highlight'; //Windows system color for general items in WHCM

exports.WHCM_HIGHLIGHT_COLOR = WHCM_HIGHLIGHT_COLOR;
var WHCM_ITEM_COLOR = 'CanvasText';
exports.WHCM_ITEM_COLOR = WHCM_ITEM_COLOR;
var OUTLINE_WIDTH = 2;
exports.OUTLINE_WIDTH = OUTLINE_WIDTH;
var OUTLINE_OFFSET = 1;
exports.OUTLINE_OFFSET = OUTLINE_OFFSET;
var BORDER_WIDTH = 1;
exports.BORDER_WIDTH = BORDER_WIDTH;
var NOT_SELECTED_OUTLINE_OFFSET = WHCM_SELECTED_ITEM_OUTLINE_OFFSET;
exports.NOT_SELECTED_OUTLINE_OFFSET = NOT_SELECTED_OUTLINE_OFFSET;